import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faHistory } from '@fortawesome/free-solid-svg-icons';
import { FaChevronDown } from 'react-icons/fa';

const Search = ({ onSearch, searchTypes, onSearchSubmit, searchQuery: externalSearchQuery, setSearchQuery: setExternalSearchQuery, searchType: externalSearchType, setSearchType: setExternalSearchType }) => {
    const [searchQuery, setSearchQuery] = useState(externalSearchQuery || '');
    const [searchType, setSearchType] = useState(externalSearchType || '');
    const [searchDropDown, setSearchDropDown] = useState(false);
    const [searchHistory, setSearchHistory] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const ref = useRef(null);
    const containerRef = useRef(null);
    const [isExpanded, setIsExpanded] = useState(false);




    // Load search history from localStorage on component mount
    useEffect(() => {
        const savedHistory = localStorage.getItem('searchHistory');
        if (savedHistory) {
            setSearchHistory(JSON.parse(savedHistory));
        }
    }, []);

    // Sync with external state
    useEffect(() => {
        setSearchQuery(externalSearchQuery || '');
        setSearchType(externalSearchType || '');
    }, [externalSearchQuery, externalSearchType]);

    const saveToSearchHistory = (query, type) => {
        if (!query.trim()) return;

        const newSearchItem = { query: query.trim(), type, timestamp: Date.now() };
        const updatedHistory = [newSearchItem, ...searchHistory.filter(
            item => !(item.query === query.trim() && item.type === type)
        )].slice(0, 10); // Keep only last 10 searches

        setSearchHistory(updatedHistory);
        localStorage.setItem('searchHistory', JSON.stringify(updatedHistory));
    };

    const handleDropDownToggle = () => {
        setSearchDropDown(!searchDropDown);
    };

    const handleClickItem = (item) => {
        setSearchType(item);
        setExternalSearchType(item);
        setSearchQuery('');
        setExternalSearchQuery('');
        onSearch('', item);
        setSearchDropDown(false);
        setShowSuggestions(true);
        
        // Immediately create a chip when dropdown item is selected
        if (onSearchSubmit) {
            onSearchSubmit('', item);
        }
    };

    const handleChangeSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        setExternalSearchQuery(query);
        // Trigger search automatically as user types
        onSearch(query, searchType);
        // Show suggestions while typing
        setShowSuggestions(true);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && searchQuery.trim() && searchType) {
            saveToSearchHistory(searchQuery.trim(), searchType);
            onSearch(searchQuery.trim(), searchType);
            // if (onSearchSubmit) {
            //     onSearchSubmit(searchQuery.trim(), searchType);
            // }
            // Show suggestions after search is completed
            setShowSuggestions(true);
        }
    };

    const handleSearchHistoryClick = (historyItem) => {
        setSearchQuery(historyItem.query);
        setExternalSearchQuery(historyItem.query);
        setSearchType(historyItem.type);
        setExternalSearchType(historyItem.type);
        onSearch(historyItem.query, historyItem.type);
        if (onSearchSubmit) {
            onSearchSubmit(historyItem.query, historyItem.type);
        }
        // Show suggestions after clicking history item
        setShowSuggestions(true);
    };

    const handleInputFocus = () => {
        setIsExpanded(true);
    };

    const getFilteredSuggestions = () => {
        return searchHistory.filter(item =>
            item.type === searchType &&
            item.query !== searchQuery // Don't show current search in suggestions
        ).slice(0, 5);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setSearchDropDown(false);
                setIsExpanded(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <div className="w-full">
            <div
                className={`relative transition-all duration-300 ease-in-out ${isExpanded ? 'w-64' : 'w-64'}`}
                ref={containerRef}
                onClick={() => setIsExpanded(true)}
            >
                <div className="flex items-center bg-white border border-gray-300 rounded-lg shadow-sm hover:border-blue-500 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 transition-all duration-300 ease-in-out">
                    <div
                        className="flex items-center space-x-2 px-3 py-2 text-gray-600 border-r border-gray-300 cursor-pointer"
                        onClick={handleDropDownToggle}
                    >
                        <FontAwesomeIcon icon={faSearch} className="text-sm " />
                        <FaChevronDown className="text-gray-400 text-xs" />
                    </div>
                    <input
                        type="text"
                        className="flex-grow px-3 py-2 text-sm text-gray-700 placeholder-gray-400 bg-transparent focus:outline-none transition-all duration-300 ease-in-out"
                        placeholder={searchType ? `Search in ${searchType}` : "Search"}
                        onChange={handleChangeSearch}
                        onKeyPress={handleKeyPress}
                        onFocus={handleInputFocus}
                        value={searchQuery}
                        disabled={!searchType}
                    />
                </div>
                {searchDropDown && (
                    <div className="absolute left-0 z-50 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg">
                        {searchTypes.map((item, index) => (
                            <div
                                key={index}
                                className="px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 cursor-pointer transition duration-150 ease-in-out"
                                onClick={() => handleClickItem(item)}
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                )}
            </div>


        </div>
    );
};

export default Search;
